// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_4152fa64 rdg_57607e17","light":"rdg_cc977a1b","dark":"rdg_a9df027e","horizontal":"rdg_dc747343"};